import React from 'react'
import { Dd } from './StyledDlElements'
import { AccountDetails } from '../../../types'
import { amountFormatter } from '../../../utils/formatter'
import { TopCardItem } from '../TopCardItem'

export const InterestAccruedTopCard: React.FC<{ account: AccountDetails }> = ({
  account,
}) => {
  return (
    <TopCardItem
      title="INTEREST ACCRUED"
      dejargContent="Interest Accrued is the daily interest accumulated from the date of your last interest payment up to today. We pay the interest that has accumulated either monthly, quarterly or annually depending on the payment schedule you selected when you opened your CD."
    >
      <Dd size="lg">
        {typeof account.interestAccrued !== 'undefined' &&
          amountFormatter.format(account.interestAccrued)}
      </Dd>
    </TopCardItem>
  )
}
